import React from 'react';
import { Statistics, Stage } from '../Home';
import { ProgressBar } from './ProgressBar';
import { ProgressBarLegend } from './ProgressBarLegend';
import { useReviewFeaturesContext } from 'contexts/ReviewFeaturesProvider';

export type StageProgressBreakdownProps = {
  stage: Stage;
} & Statistics;

export type StageCounts = {
  complete: number;
  partiallyComplete: number;
  consensusRequired?: number;
  notStarted: number;
};

const StageProgressBreakdown = ({
  complete,
  partiallyComplete,
  consensusRequired,
  notStarted,
  stage,
}: StageProgressBreakdownProps) => {
  const { isLoading, isStructuredSingleExtractor } = useReviewFeaturesContext();

  if (stage == 'included' && isLoading) {
    return null; // Render nothing until review settings retrieved, to avoid obvious re-render
  }

  const singleReviewerExtraction =
    stage == 'included' && isStructuredSingleExtractor;

  const legacyCounts: {
    complete?: number;
    consensusRequired?: number;
    partiallyComplete: number;
    notStarted: number;
  } = { complete, partiallyComplete, consensusRequired, notStarted };

  if (singleReviewerExtraction) {
    delete legacyCounts.consensusRequired;
  }

  const counts: StageCounts = {
    complete,
    partiallyComplete,
    consensusRequired: singleReviewerExtraction ? undefined : consensusRequired,
    notStarted,
  };

  return (
    <>
      <ProgressBar stage={stage} {...counts} />
      <ProgressBarLegend {...counts} stage={stage} />
    </>
  );
};

export default StageProgressBreakdown;
